module.exports = __webpack_public_path__ + "media/icons/up_to_date-6bfa788f.svg";